import { useEffect } from 'react';

import { useAppDispatch } from '../../app/hooks';
import { rootApi } from '../../app/rootApi';
import { Topic } from './types';

const cacheTtlSeconds = 60 * 60;

// TODO, this doesn't use the config/aws.ts lookup mechanism so can't be tested with a locally running referral service
const referralApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getPresentations: builder.query<Topic[], void>({
            query: () => ({
                api: 'referral',
                endpoint: `public/topics`,
                method: 'GET',
            }),
            providesTags: ['ReferralTopics'],
            keepUnusedDataFor: cacheTtlSeconds,
        }),
    }),
    overrideExisting: false,
});

export const { useGetPresentationsQuery, useLazyGetPresentationsQuery } = referralApi;

export function usePrefetchTopics() {
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(referralApi.util.prefetch('getPresentations', undefined, {}));
    }, [dispatch]);
}
